/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import '../../Landing/Landing.scss'

import Header from '../../../components/Header'
import Footer from '../../../components/footer'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { get } from '../../../services/https'
import { ToRial } from '../../../services/money'

import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'

export default function Success() {
  const navigate = useNavigate()

  const { id } = useParams()

  const [order, setOrder] = useState([])
  const [orderBasket, setOrderBasket] = useState([])
  const [statusPage, setStatusPage] = useState(false)
  const [orderStatus, setOrderStatus] = useState('')

  useEffect(() => {
    get(`/api/front/order/details/${id}`)
      .then(response => {
        setOrder(response.data.data)
        setOrderBasket(response.data.data.basket)
        setStatusPage(true)

        switch(response.data.data.orderStatus) {
          case 'new':
            setOrderStatus('سفارش جدید')
            break
          case 'doing':
            setOrderStatus('سفارش در حال انجام')
            break
          case 'ready':
            setOrderStatus('سفارش آماده تحویل')
            break
          case 'done':
            setOrderStatus('تحویل داده شده')
            break
          case 'cancel':
            setOrderStatus('سفارش کنسل شده')
            break
          default :
            setOrderStatus('')
            break
        }
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [])

  return (
    <div id='SignUp'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <div className="bill" style={statusPage ? { filter: 'blur(0px)' } : { filter: 'blur(5px)' }}>
          {order ? (
            <div className='refId' style={{ margin: '1em 0 0 0' }}>کد پرداخت : {order.refId}</div>
          ) : ''}
          {order ? (
            <div className='orderNumber'>شماره سفارش : {order.orderNumber}</div>
          ) : ''}
          {orderBasket ? (
            <ul className='orderNumber'>
              {orderBasket.map(item => (
                <li key={item._id}>
                  <span>{(item.name).substr(0, 30)}</span>
                  <span>تعداد : {item.count}</span>
                </li>
              ))}
            </ul>
          ) : ''}
          {order ? (
            <div className='orderNumber'>جمع سبد خرید : {ToRial(String(order.productsTotal))} تومان</div>
          ) : ''}
          {order ? (
            <div style={order.shippingCost !== 0 ? { display: '' } : { display: 'none' }} className='orderNumber'>هزینه ارسال : {ToRial(String(order.shippingCost))} تومان</div>
          ) : ''}
          {order ? (
            <div className='orderNumber'>پرداختی : {ToRial(String(order.total))} تومان</div>
          ) : ''}
          {order ? (
            <div className='orderStatus'>وضعیت سفارش : {orderStatus}</div>
          ) : ''}
          <hr />
          <div className='problem'>در صورت وجود هرگونه مشکل می توانید با پشتیبانی در تماس باشید</div>
        </div>
        <div className="bilButtonCountainer">
          <button onClick={() => navigate('/order')}>بازگشت به سفارشات</button>
        </div>
      </div>
      <Footer page={''} />
    </div>
  )
}
